<template>
    <div class="bg-white p-3">
        <b-row>
            <b-col cols="12" class="d-flex">
                <!-- <b-button-group> -->
                <strong class="me-auto align-self-center">{{ $translate("page") }}: {{ currentPage }} {{ $translate("of") }}
                    {{ Math.ceil(historyrows / itemsPerPage) }} {{ $translate("total") }}:
                    {{ historyrows }}</strong>
                <b-button variant="blue-button" class="me-2" @click="shouldShowFilters = !shouldShowFilters">
                    <span style="white-space: nowrap">
                        {{ $translate('filters') }}
                        <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                            }`"></b-icon>
                    </span>
                </b-button>
                <b-button variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                    :title="$translate('reset_filters')">
                    <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                </b-button>
                <!-- </b-button-group> -->
            </b-col>
            <b-col class="text-right mb-2" cols="4">
                <slot></slot>
            </b-col>
        </b-row>
        <HistoryItemsQueryFilter class="mt-3" v-show="shouldShowFilters" :officer-option="officerOption"
            :locations="locations" :orderTypes="orderTypes" :officers="users" ref="queryFilter" v-model="filters"
            :disabled-officers="!hasPermissionView" />
        <!-- <p class="mt-3"> -->
        <div class="mt-3">
            <!-- </p> -->
            <b-table v-model="historytabledata" :per-page="historyitemsPerPage" :current-page="currentPage" :fields="fields"
                striped hover :busy="historytableLoading" ref="table" responsive :items="historyItems" class="mt-3">
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <!-- <strong>{{ $translate('loading') }}</strong> -->
                    </div>
                </template>
                <template #cell(location_section)="{ item }">
                    <div v-html="getInventoryLocation(item)"></div>
                </template>

                <template #cell(activity_type)="{ item }">
                    <div>
                        {{
                            (
                                orderTypes.find(
                                    x => item.order.order_type_id == x.id
                                ) || {}
                            ).name
                        }}
                    </div>
                </template>
                <template #cell(activity)="{ item }">
                    <div>
                        <b-link :to="`/ams/activities/${item.order.id}`">
                            {{ item.order.reference_no }}</b-link>
                    </div>
                </template>
            </b-table>
            <b-row>
                <b-col class="d-flex justify-content-center mt-4">
                    <b-pagination class="float-right" v-model="currentPage" :total-rows="historyrows"
                        :per-page="historyitemsPerPage" :next-text="$translate('next')" :prev-text="$translate('previous')"
                        aria-controls="roleTable" pills align="right"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <portal-target name="history"></portal-target>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import HistoryItemsQueryFilter from './HistoryItemsQueryFilter.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
import showItemHelper from '@/mixins/showItemHelper'
import importMixins from '@/mixins/importMixins'

const defaultModel = Object.freeze({
    created_start: moment().subtract(30, 'days').format('YYYY-MM-DD'),

    created_end: moment().format('YYYY-MM-DD'),
})
const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}
export default {
    name: 'inventoryTransfer-HistoryListItems',
    components: { HistoryItemsQueryFilter },
    props: ['type', 'title', 'item'],
    // mixins: [popupMixins, permissionsMixins],
    mixins: [popupMixins, permissionsMixins, showItemHelper, importMixins],

    data() {
        return {
            query: '',
            model: { ...defaultModel },
            historytableLoading: false,
            historytabledata: [],
            selectedFromDate: '',
            selectedProductId: '',
            selectedToDate: '',
            itemsPerPage: 15,
            historyitemsPerPage: 15,
            currentPage: 1,
            shouldShowFilters: false,
            filters: {
                product_search: null,
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                fromDate: defaultModel.created_start,
                toDate: defaultModel.created_end,
            },
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    watch: {
        dateRange: function (val) {
            switch (val) {
                case dateRangeEnum.today:
                    this.model.created_start = moment()
                        .subtract(30, 'days')
                        .format('YYYY-MM-DD')
                    this.model.created_end = moment().format('YYYY-MM-DD')
                    break
                case dateRangeEnum.yesterday:
                    this.model.created_start = moment()
                        .subtract(31, 'days')
                        .format('YYYY-MM-DD')
                    this.model.created_end = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    break
                default:
                    break
            }
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        query: _.debounce(function (query) {
            //console.log("query:", query)
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),

        report_loading: function (val) {
            this.$emit('report-state', val)
        },

        historyItems: {
            handler: function () {
                this.historytableLoading = false
            },
        },
    },
    computed: {
        // historyitemFields() {
        //     return [
        //         {
        //             key: 'item Code',
        //             label: this.$translate('item_code'),
        //             formatter: (value, key, item) => item.ext_reference_code,
        //         },
        //         {
        //             key: 'updated_at',
        //             label: this.$translate('transaction_date'),
        //             formatter: value =>
        //                 !value ? '' : this.formatDateTime(value), // tk: To be revisited
        //         },
        //         {
        //             key: 'Product Name',
        //             label: this.$translate('product_name'),
        //             formatter: (value, key, item) => item.name,
        //         },

        //         {
        //             key: 'Item Type',
        //             label: this.$translate('item_type'),
        //             formatter: (value, key, item) => item.type.name,
        //         },
        //         {
        //             key: 'UOM',
        //             label: this.$translate('uom'),
        //             formatter: (value, key, item) => item.uom,
        //         },
        //         {
        //             key: 'From',
        //             label: this.$translate('from_warehouse_location_section_Officer'),
        //             formatter: (value, key, item) =>
        //                 `${item.sections[0] &&
        //                 item.sections[0].location_section.location.name
        //                 } /${item.sections[0] &&
        //                 item.sections[0].location_section.officers[0] &&
        //                 item.sections[0].location_section.officers[0]
        //                     .first_name
        //                 }`,
        //         },

        //         {
        //             key: 'To',
        //             label: this.$translate('to_warehouse_location_section_Officer'),
        //         },
        //         {
        //             key: 'Qty Transfer',
        //             label: this.$translate('qty_on_hand'),
        //         },

        //         {
        //             key: 'Note',
        //             label: this.$translate('note'),
        //         },
        //     ]
        // },

        fields() {
            return [
                { key: 'id', label: this.$translate('id') },
                {
                    key: 'location_section',
                    label: this.$translate('locations'),
                },
                {
                    key: 'datetime',
                    label: this.$translate('date_time'),
                    formatter: (value, key, item) =>
                        new Date(item.sortedTime).toLocaleDateString() +
                        ' ' +
                        new Date(item.sortedTime).toLocaleTimeString(),
                },
                {
                    key: 'added_amount',
                    label: this.$translate('movements'),
                },
                {
                    key: 'activity_type',
                    label: this.$translate('activity_type'),
                },
                {
                    key: 'activity',
                    label: this.$translate('activity'),
                }

                // // 'activity_type',
                // 'activity',
            ]
        },
        officerOption() {
            return '----officers----'
        },
        defaultFromDate() {
            return moment().subtract(30, 'days').toDate() // 30 days ago from today
        },
        defaultToDate() {
            return new Date() // today's date
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
        users() {
            return this.$store.getters['users/sorted_officers']
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse || x.sections.some(y => !y.is_officer)
            )
        },
        historyItems() {
            const historyItemsArray = this.$store.state.masterItem.historyItems.flatMap(data =>
                data.sections.flatMap(section =>
                    section.transactions.map(transaction => ({
                        location_section: section.location_section,
                        sortedTime: new Date(transaction.created_at).getTime(),
                        quantity_on_hand: section.quantity_on_hand,
                        ...transaction,
                    }))
                )
            );
            return this.historyFilterdData(historyItemsArray);

        },
        sectionItems() {
            return this.$store.state.masterItem
        },
        historyrows() {
            const historyitemRows =
                this.historyItems.length
            return historyitemRows
        },
        products() {
            const _items = this.$store.state.masterItem.section_items
            return _items
        },
    },
    methods: {
        historyFilterdData(historydata) {
            //filter out non warehouses
            const {
                fromDate,
                toDate,
                location_id,
                officer_id,
                order_item_type_id,
            } = this.filters
            let data = [...(historydata || [])].filter(
                x =>
                    !x.location_section ||
                    x.location_section.is_officer ||
                    x.location_section.officers.length ||
                    x.location_section.location.is_warehouse
            )
            if (parseInt(location_id, 10)) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        x.location_section.location.id == location_id &&
                        x.location_section.location.is_warehouse &&
                        x.location_section.officers.length == 0
                )
            }

            if (location_id === this.officerOption) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        (x.location_section.is_officer ||
                            x.location_section.officers.length)
                )
            }
            if (officer_id) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        x.location_section.officers[0] &&
                        x.location_section.officers[0].id == officer_id
                )
            }
            if (order_item_type_id) {
                data = data.filter(x => x.order.order_type_id == order_item_type_id)
            }
            if (fromDate && toDate) {
                data = data.filter(x => new Date(x.created_at) >= new Date(fromDate) && new Date(x.created_at) <= new Date(toDate))
            }
            return data
        },
        getInventoryLocation({ location_section, quantity_on_hand }) {
            console.log('location_section', location_section)
            if (!location_section) {
                return ''
            }

            if (location_section.officers.length) {
                return (
                    `<strong>${this.$translate('officer')}</strong>: ` +
                    (location_section.officers[0] &&
                        location_section.officers[0].first_name +
                        ' ' +
                        location_section.officers[0].last_name) +
                    '(' +
                    quantity_on_hand +
                    ')'
                )
            } else if (location_section.location.is_warehouse) {
                return (
                    location_section.location.name +
                    `:` +
                    location_section.name +
                    '(' +
                    quantity_on_hand +
                    ')'
                )
            } else {
                return 'Customer Location'
            }
        },
        getReportQuery() {
            return { name: this.query }
        },
        resetFilters() {
            this.filters = {
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                fromDate: null,
                toDate: null,
            }
        },
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        doSearch() {
            this.historytableLoading = true
            this.$store.dispatch('masterItem/fetchHistory')
        },
    },
}
</script>
